import { useCallback, useEffect, useState } from 'react';
import {
  FIXED_EMPLOYEE_STORAGE_KEY,
  clearFixedEmployeeId,
  getFixedEmployeeId,
  setFixedEmployeeId,
} from './fixed-employee.util';

type UseFixedEmployeeResult = {
  fixedEmployeeId: number | null;
  setFixedEmployee: (employeeId: number) => void;
  clearFixedEmployee: () => void;
};

// Device-local fixed-employee state on its own key, with cross-tab storage sync.
export function useFixedEmployee(): UseFixedEmployeeResult {
  const [fixedEmployeeId, setFixedEmployeeIdState] = useState<number | null>(() => getFixedEmployeeId());

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === FIXED_EMPLOYEE_STORAGE_KEY) {
        setFixedEmployeeIdState(getFixedEmployeeId());
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const setFixedEmployee = useCallback((employeeId: number) => {
    setFixedEmployeeId(employeeId);
    setFixedEmployeeIdState(employeeId);
  }, []);

  const clearFixedEmployee = useCallback(() => {
    clearFixedEmployeeId();
    setFixedEmployeeIdState(null);
  }, []);

  return { fixedEmployeeId, setFixedEmployee, clearFixedEmployee };
}
